/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloading_Subtitle_File_WaitInputs */



/**
* | output |
* | --- |
* | "Downloading subtitle file... please wait..." |
*
* @param {Downloading_Subtitle_File_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const downloading_subtitle_file_wait = /** @type {((inputs?: Downloading_Subtitle_File_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloading_Subtitle_File_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargement du fichier de sous-titres... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei wird heruntergeladen... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Download del file dei sottotitoli... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка файла субтитров... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargando archivo de subtítulos... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在下载字幕文件……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルをダウンロードしています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबटाइटल फाइल डाउनलोड हो रही है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixando arquivo de legenda... aguarde...")
	return /** @type {LocalizedString} */ ("Downloading subtitle file... please wait...")
});